import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes("assets/i18n/")) {
    return next(req);
  }

  const translateService = inject(TranslateService);
  return next(
    req.clone({
      headers: req.headers.set("Accept-Language", translateService.getCurrentLang()),
    })
  );
};
